import React, { useState, useMemo, useEffect } from "react";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import ImportImg from "../../../Assets/Images/CommanImages/fileexport.png";

// Set a custom icon for the custom "importtemplate" button
const icons = Quill.import("ui/icons");
icons["importtemplate"] = `<img src="${ImportImg}" style="width:18px; height:18px; vertical-align:middle;" alt="Import" />`;

const TextEditor = ({ templates = [], value = "", setValue }) => {
  const [editorHtml, setEditorHtml] = useState(value);
  const [showModal, setShowModal] = useState(false);

  // Update local state when parent's value changes
  useEffect(() => {
    setEditorHtml(value);
  }, [value]);

  const handleChange = (html) => {
    setEditorHtml(html);
    if (setValue) {
      setValue(html);
    }
  };

  const handleTemplateClick = (templateHtml) => {
    setEditorHtml(templateHtml);
    if (setValue) {
      setValue(templateHtml);
    }
    setShowModal(false);
  };

  const modules = useMemo(() => ({
    toolbar: {
      container: [
        ["bold", "italic", "underline"],
        [{ color: [] }],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ indent: "-1" }, { indent: "+1" }],
        ["importtemplate"]
      ],
      handlers: {
        importtemplate: () => setShowModal(true)
      }
    }
  }), []);

  const formats = ["bold", "italic", "underline", "color", "list", "bullet", "indent"];

  return (
    <div>
      <div style={{ marginBottom: "4px", marginTop: "2px", color: "GrayText" }}>
        Instructions
      </div>
      <ReactQuill
        value={editorHtml}
        onChange={handleChange}
        modules={modules}
        formats={formats}
        placeholder="Write something..."
        style={{ minHeight: "200px" }}
      />
      {/* Modal for selecting a template */}
      {showModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 1000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: "20px",
              borderRadius: "8px",
              width: "80%",
              maxWidth: "500px",
              boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
              maxHeight: "80%",
              overflowY: "auto"
            }}
          >
            <h3 style={{ marginTop: 0, marginBottom: "10px" }}>
              Select a Template
            </h3>
            {templates && templates.length > 0 ? (
              <ul style={{ listStyle: "none", paddingLeft: 0 }}>
                {templates.map((template) => (
                  <li
                    key={
                      template.dpp_inst_template_id ||
                      template.test_inst_template_id ||
                      template.id
                    }
                    onClick={() =>
                      handleTemplateClick(
                        template.dpp_instruction_html ||
                          template.test_instruction_html ||
                          template.html
                      )
                    }
                    style={{
                      cursor: "pointer",
                      padding: "10px",
                      borderBottom: "1px solid #eee",
                      marginBottom: "5px",
                      border: "1px solid #ccc"
                    }}
                  >
                    {template.dpp_inst_template_name ||
                      template.test_inst_template_name ||
                      template.name}
                    <br />
                    <small style={{ color: "#666" }}>
                      {template.dpp_template_desc ||
                        template.test_template_desc ||
                        template.desc}
                    </small>
                  </li>
                ))}
              </ul>
            ) : (
              <p>No templates available.</p>
            )}
            <button
              onClick={() => setShowModal(false)}
              style={{
                marginTop: "20px",
                padding: "8px 16px",
                cursor: "pointer"
              }}
              className="create-test-section-btn"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default TextEditor;